import type { PhotosFormData } from './registration';

const stripPhotoCacheParam = (url: string): string => url.split('?')[0] ?? url;

export type PhotoPosition = 'front' | 'back' | 'right' | 'left';

export type PhotoFormKey = 'front' | 'back' | 'rightSide' | 'leftSide';

export const PHOTO_POSITION_TO_FORM_KEY: Record<PhotoPosition, PhotoFormKey> = {
  front: 'front',
  back: 'back',
  right: 'rightSide',
  left: 'leftSide',
};

export const PHOTO_FORM_KEY_TO_POSITION: Record<PhotoFormKey, PhotoPosition> = {
  front: 'front',
  back: 'back',
  rightSide: 'right',
  leftSide: 'left',
};

export interface StudentPhoto {
  id: number;
  student_id: number;
  position: PhotoPosition;
  url: string;
  uploaded_at: string;
}

export const createEmptyPhotosFormData = (): PhotosFormData => ({
  front: null,
  back: null,
  rightSide: null,
  leftSide: null,
});

export const mapStudentBodyPhotosToFormData = (
  bodyPhotos: StudentPhoto[],
  options?: { bustCache?: boolean },
): PhotosFormData => {
  const loadedPhotos = createEmptyPhotosFormData();
  const bustCache = options?.bustCache ?? true;

  bodyPhotos.forEach((photo) => {
    const formKey = PHOTO_POSITION_TO_FORM_KEY[photo.position];
    const preview = bustCache
      ? `${photo.url}${photo.url.includes('?') ? '&' : '?'}t=${Date.now()}`
      : photo.url;
    loadedPhotos[formKey] = { preview, stored: true };
  });

  return loadedPhotos;
};

export const serializePhotosSnapshot = (
  photos: PhotosFormData,
  pendingDeletions: PhotoPosition[] = [],
): string => JSON.stringify({
  previews: {
    front: photos.front?.preview ? stripPhotoCacheParam(photos.front.preview) : null,
    back: photos.back?.preview ? stripPhotoCacheParam(photos.back.preview) : null,
    rightSide: photos.rightSide?.preview ? stripPhotoCacheParam(photos.rightSide.preview) : null,
    leftSide: photos.leftSide?.preview ? stripPhotoCacheParam(photos.leftSide.preview) : null,
  },
  pendingDeletions: [...pendingDeletions].sort(),
});
